export enum JobStatus {
  Processing = 'Processing',
  InQueue = 'InQueue',
  Finished = 'Finished',
  Canceled = 'Canceled',
  Canceling = 'Canceling',
}
